<template>
  <div ref="wrapper" class="fd__wrapper" id="scrollTarget">
    <v-autocomplete
      v-model="filterableDropdownValue"
      :items="selectItems"
      :loading="loading"
      :label="name"
      :disabled="disabled"
      :placeholder="placeholder"
      item-value="value"
      item-text="text"
      :filter="selectFilter"
      :menu-props="{ maxHeight: 400 }"
      :no-data-text="$t('text_0ueq')"
      clearable
      hide-details
      append-icon="mdi-menu-down"
      @change="emitChange"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      filterableDropdownValue: this.value,
      filterString: '',
      category: 0,
    };
  },
  props: {
    name: { type: String, default: '' },
    value: {
      type: [String, Number, Boolean, Date, Object, Array],
      default: null,
    },
    placeholder: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    showEmptyItem: { type: Boolean, default: false },
    emptyItemText: { type: String, default: null },
    emptyItemValue: { type: String, default: null },
    items: { type: Array, default: null },
    idKey: { type: String, default: null },
    valueKey: { type: String, default: null },
    textKey: { type: String, default: null },
    localeKey: { type: String, default: null },
    filterTargetKey: { type: String, default: null },
    filterTargetKanaKey: { type: String, default: null },
    ignoreCase: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
  },
  computed: {
    categoryList() {
      return [
        { id: 0, label: this.$t('all') },
        { id: 1, label: this.$t('love_hotel') },
        { id: 2, label: this.$t('rental_room') },
        { id: 3, label: this.$t('business_city_hotel') },
      ];
    },
    categoryFilterItems() {
      let items = [];
      if (this.loading) {
      } else {
        if (this.category === 0) {
          items = this.items;
        } else {
          items = this.items.filter((v) => v.category === this.category);
        }
      }
      return items;
    },
    selectItems() {
      return this.categoryFilterItems.map((item) => ({
        value: this.valueKey ? item[this.valueKey] : item,
        text:
          this.textKey
            ? item[`${this.textKey}_${this.localeKeyComputed}`] ||
              item[this.textKey] ||
              item
            : item,
      }));
    },
    localeKeyComputed() {
      if (this.localeKey) return this.localeKey;
      switch (this.$i18n.locale) {
        case 'zh-cn':
          return 'zh_cn';
        case 'zh-tw':
          return 'zh_tw';
        case 'ko':
          return 'ko';
        default:
          return 'en';
      }
    },
  },
  methods: {
    selectFilter(item, queryText, itemText) {
      const search = queryText.toLowerCase();
      const text = (itemText || '').toString();
      return this.kanaCompare(text, search);
    },
    kanaCompare(str, query) {
      const hira = str.replace(/[\u30A2-\u30F3]/g, (m) =>
        String.fromCharCode(m.charCodeAt(0) - 96)
      );
      return (
        str.toLowerCase().includes(query) || hira.includes(query)
      );
    },
    emitChange(val) {
      this.$emit('input', val);
      this.$emit('emitChangeHotel');
    },
  },
  watch: {
    value(val) {
      this.filterableDropdownValue = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.fd__wrapper {
  position: relative;
  * {
    font-size: 1rem;
  }
  input.fd__display-textbox,
  input.fd__filter-textbox {
    width: 100%;
  }
  // .fd__list {
  //   position: absolute;
  //   z-index: 1;
  //   top: 100%;
  //   left: 0;
  //   width: 100%;
  //   padding: 2px;
  //   border: solid 1px rgb(192, 192, 192);
  //   background: white;
  //   box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.2);
  //   margin-top: -1px;
  //   ul {
  //     margin: 4px 0 0 0;
  //     padding: 2px;
  //     overflow-x: auto;
  //     overflow-y: scroll;
  //     max-height: 20vh;
  //     li {
  //       padding: 2px 1px;
  //       cursor: pointer;
  //       list-style: none;
  //       line-height: 1;
  //       &.fd__item:hover {
  //         background: rgb(250, 114, 196);
  //       }
  //     }
  //   }
  // }
  .usr-call-search-cond__btn {
    font-size: 11px;
    font-weight: bold;
    color: var(--read-font-color-sub);
    box-shadow: 0 1.5px 1.5px 0 rgba(0, 0, 0, 0.1),
      0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 2px 1px -2px rgba(0, 0, 0, 0.2) !important;
  }
  .v-btn--active {
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1), 0 1px 3px 0 rgba(0, 0, 0, 0.1),
      0 2px 1px -2px rgba(0, 0, 0, 0.2) !important;
    color: var(--main-color) !important;
  }
}
div[aria-disabled='true'] {
  background: #696969;
  color: #fff;
}
</style>
